export default [
    {
        value: {
            value: 'diamond',
            id: 1,
            label: 'Diamante'
        },
    }, {
        value: {
            value: 'sapphire',
            id: 2,
            label: 'Zafiro',
        },
    }, {
        value: {
            value: 'golden',
            id: 3,
            label: 'Oro',
        },
    }, {
        value: {
            value: 'silver',
            id: 4,
            label: 'Plata',
        },
    }, {
        value: {
            value: 'bronze',
            id: 5,
            label: 'Bronce',
        },
    }
];
